// ==============================|| OVERRIDES - LIST ITEM ICON ||============================== //

import colors from "../../utils/colors";

export default function MenuItem(theme) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          backgroundColor: colors.neutral[100],
          paddingTop: "3px",
          paddingLeft: "12px",
          paddingRight: "12px",
          paddingBottom: "3px",
          minHeight: "40px",
          height: "40px",
          fontSize: 14,
          lineHeight: "21px",
          color: colors.neutral[800],
          ...theme.typography.formField,
          "& .MuiTypography-root": {
            fontSize: 14,
            lineHeight: "21px",
            color: colors.neutral[800],
          },
          "&:hover": {
            backgroundColor: colors.primary.alpha,
            color: colors.primary[300],
          },
          "&.Mui-selected": {
            backgroundColor: colors.primary.alpha,
            color: colors.primary[500],
            fontWeight: 500,
          },
          "&.Mui-selected:hover": {
            backgroundColor: colors.primary.alpha,
            color: colors.primary[300],
          },
          "&.Mui-focusVisible": {
            backgroundColor: colors.primary.alpha,
          },
          "&:first-child": {
            borderRadius: "8px 8px 0px 0px",
          },
          "&:last-child": {
            borderRadius: "0px 0px 8px 8px",
          },
        },
      },
    },
  };
}
